import i18next from "i18next";
import { html } from "lit-html";
import { WIDGETS } from "Services/constants";

export interface Props {
	culture: string;
}

export const useTransfersTab = (props: Props) => {
	const htmlTemplate = () => {
		const transferUrl =
			WIDGETS.get(props.culture.toLowerCase())?.transferUrl || WIDGETS.get("default")?.transferUrl;

		return html`
			<div class="mt-4 text-sm text-n-blue">
				${i18next.t("search-box-transfer")} <span class="text-lg font-semibold italic">Cartrawler</span>
			</div>
			<iframe src=${transferUrl} height="432" width="100%" scrolling="no" frameborder="0"></iframe>
		`;
	};

	return { htmlTemplate };
};
